import fetch from '@/utils/fetch';
import {systemFetch} from '@/utils/fetch';

// 根据字典code获得字典数据公共接口
export function findDicsByCode(args) {
    let params = new URLSearchParams();
    params.append('dicCode', args.dicCode);

    return fetch({
        url: 'common/sysDictionary/findDicsByCode',
        method: 'post',
        data: params
    });
}

// 获得学校下某个字典的字典值列表

export function findSchoolDicsByCode(args) {
    let params = new URLSearchParams();
    params.append('dicCode', args.dicCode);
    params.append('schoolId', args.schoolId);

    return fetch({
        url: 'common/schoolDictionary/findSchoolDicsByCode',
        method: 'post',
        data: params
    });
}

// 根据ID获得学校信息
export function queryById(args) {
    let params = new URLSearchParams();
    params.append('id', args.id);

    return fetch({
        url: 'common/school/queryById',
        method: 'post',
        data: params
    });
}

export function getWxCosFileSign(args = {sysBucket: 1}) {
    let params = new URLSearchParams()
    params.append('sysBucket', args.sysBucket)
    return fetch({
        baseURL: global.BasePath,
        url: 'common/getWxCosFileSign',
        method: 'get',
        params
    })
}

export function queryIntegrateModuleRedirectUrl(args) {
    const params = new URLSearchParams();
    params.append('entranceType', 1);
    params.append('sourceType', 1);
    params.append('id', args.id);

    return systemFetch({
        url: 'api/module/school/queryIntegrateModuleRedirectUrl',
        method: 'GET',
        params
    });
}
export function getSchoolYear(args) {
    let params = new URLSearchParams();

    return fetch({
        url: 'structure/schoolTime/getSchoolYear',
        method: 'POST',
        params
    });
}
export function getCurrentSchoolTimeBySchoolId(args) {
    let params = new URLSearchParams();
    params.append('schoolId', args.schoolId);

    return fetch({
        url: 'common/schooltime/getCurrentSchoolTimeBySchoolId',
        method: 'GET',
        params
    });
}
//获取当前学期
export function getCurrentSchoolTimeBySchoolIdS() {
    return fetch({
        url: 'structure/schoolTime/getCurrentSchoolTimeBySchoolId',
        method: 'GET'
    });
}



// WEBPACK FOOTER //
// ./src/api/common.js